import { BehaviorSubject } from 'rxjs';

const playingStreamingMatchId$ = new BehaviorSubject(-1);

const isScrolledTop$ = new BehaviorSubject(false);

const setPlayingStreamingMatchId = (matchId: number) => playingStreamingMatchId$.next(matchId);

const setIsScrolledTop = (y: number) => isScrolledTop$.next(y < 36);

export const miniStreamingService = {
	onPlayingStreamingChange$: playingStreamingMatchId$.asObservable(),
	isScrolledNearTop: isScrolledTop$.asObservable(),
	setPlayingStreamingMatchId,
	setIsScrolledTop,
	get getPlayingStreamingMatchId() {
		return playingStreamingMatchId$.value;
	}
};